$(function(){
    var moment = require('moment');
    moment.locale('hu');

    var toDateInputValue = (function(d) {
        var local = new Date(d);
        local.setMinutes(local.getMinutes() - local.getTimezoneOffset());
        return local.toJSON().slice(0,10);
    });

    $('.action-today').click(function(){
        $(this).parents('.input-group').find('input').val(toDateInputValue(new Date));
    })

    $('.action-now').click(function(){
        var $input =$(this).parents('.input-group').find('input');
        $input.val(moment().format($input.attribute('format')));
    })

    var ranges = {
        'Ma': [moment(), moment()],
        'Tegnap': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
        'Elmúlt 7 nap': [moment().subtract(6, 'days'), moment()],
        'Elmúlt 30 nap': [moment().subtract(29, 'days'), moment()],
        'Ez a hónap': [moment().startOf('month'), moment().endOf('month')],
        'Előző hónap': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
    };

    function formatDate(start, end){
        var text = '';
        var d1 = start.diff(end, 'days');
        var d2 = start.diff(moment(), 'days');
        if(d1 == 0 && d2 == 0){
            text = 'Ma';
        }else if(d1 == 0 && d2 == -1){
            text = 'Tegnap';
        }else if(d1 == -6 && d2 == -6){
            text = 'Elmúlt 7 nap';
        }else if(d1 == -29 && d2 == -29){
            text = 'Elmúlt 30 nap';
        }else if(start.diff(ranges['Ez a hónap'][0], 'days') == 0 && end.diff(ranges['Ez a hónap'][1], 'days') == 0){
            text = 'Ez a hónap';
        }else if(start.diff(ranges['Előző hónap'][0], 'days') == 0 && end.diff(ranges['Előző hónap'][1], 'days') == 0){
            text = 'Előző hónap';
        }else{
            var formatYear = '';
            if(start.format('YYYY') !== moment().format('YYYY') || end.format('YYYY') !== moment().format('YYYY')){
                formatYear = 'YYYY ';
            }
            if(end.diff(start, "days") > 0) {
                text =
                    start.format( formatYear + 'MMM DD') +
                    ' - ' +
                    end.format( formatYear + 'MMM DD');
            }else{
                text = start.format( formatYear + 'MMMM DD')
            }

            if(end.diff(start, "years") > 0){
                text += ' ('+(end.diff(start, "years")) + " Év )"
            }else if(end.diff(start, "months") > 0){
                text += ' ('+(1 + end.diff(start, "months")) + " Hónap )"
            }else if(end.diff(start, "days") > 0){
                text += ' ('+(1 + end.diff(start, "days")) + " Nap )"
            }
        }
        return text;
    }
    $('.daterange').daterangepicker({
        ranges: ranges,
        opens: 'center',
        showDropdowns: true,
        showWeekNumbers: false,
        timePicker: false,
        alwaysShowCalendars:true,
        maxDate: moment(),
        autoApply: true,
        locale: {
            direction: 'ltr',
            format: 'YYYY-MM-DD',
            separator: ' - ',
            applyLabel: 'Alkalmaz',
            cancelLabel: 'Mégsem',
            weekLabel: 'W',
            customRangeLabel: 'Egyedi intervallum',
            daysOfWeek: moment.weekdaysMin(),
            monthNames: moment.monthsShort(),
            firstDay: moment.localeData().firstDayOfWeek()
        }
    }, function(start, end, label, element = null) {
        element = element || this.element;
        $(element).find('input').val(start.format('YYYY-MM-DD') + ' - ' + end.format('YYYY-MM-DD'));

        $(element).find('span').html( formatDate(start, end) );
    });
    $('.daterange').each(function(){
        var val = $(this).find('input').val()
        var parts = val.split(' - ');
        var start = moment(parts[0]).hour(12);
        var end = moment(parts[1]).hour(12);
        var text = formatDate(start, end);
        $(this).find('span').html( text );

        $(this).data('daterangepicker').setStartDate(start);
        $(this).data('daterangepicker').setEndDate(end);
    })

    $('.datepicker:not([disabled])').each(function() {
        $(this).datepicker({
            format: 'yyyy-mm-dd',
            autoclose:true,
            assumeNearbyYear: true,
            clearBtn: $(this).prop('required'),
            enableOnReadonly:false,
            startDate: $(this).data('min') ? moment($(this).data('min')).format('YYYY-MM-DD') : ($(this).hasClass('shortPast')  ? moment('2019-01-01').format('YYYY-MM-DD')  : null),
            endDate: $(this).data('max') ? moment($(this).data('max')).format('YYYY-MM-DD') : ($(this).hasClass('shortFuture') ? moment().endOf('day').format('YYYY-MM-DD') : null),
            language:'hu',
            maxViewMode:1,
            todayHighlight:true,

            beforeShowDay:function(date){
                    var key = moment(date).format('YYYY-MM-DD');
                    var val = window.workdayData && (val = window.workdayData[key])
                    if(val !== undefined){
                        return {
                            'enabled': val==1,
                            'classes': val== 1 ? 'extraWeekday' : 'extraWeekend'
                        };
                    }
                    return
                }
        });
    });

    $('input.datetimepicker:not([disabled])').each(function() {
        var date = $(this).val() ? moment($(this).val()) : null;
        $(this).daterangepicker({
            singleDatePicker: true,
            opens: 'center',
            showWeekNumbers: false,
            minDate: $(this).data('min') ? moment($(this).data('min')) : ($(this).hasClass('longPast')  ? null : moment('2019-01-01')),
            maxDate: $(this).data('max') ? moment($(this).data('max')) : ($(this).hasClass('longFuture')? null : moment().endOf('day')),
            timePicker: true,
            timePicker24Hour: true,
            timePickerSeconds: false,
            alwaysShowCalendars: true,
            autoApply: true,
            startDate: date,

            endDate: date,
            locale: {
                direction: 'ltr',
                format: 'YYYY-MM-DD HH:mm:ss',
                separator: ' - ',
                applyLabel: 'Alkalmaz',
                cancelLabel: 'Mégsem',
                weekLabel: 'W',
                customRangeLabel: 'Egyedi intervallum',
                daysOfWeek: moment.weekdaysMin(),
                monthNames: moment.monthsShort(),
                firstDay: moment.localeData().firstDayOfWeek()
            }
        });
    });
})
